module.exports = __webpack_public_path__ + "static/media/dashboard.8d576ea0.svg";